import { Col, Container, Row, Tab } from "react-bootstrap";
import Nav from "react-bootstrap/Nav";
import { ProjectCard } from "./ProjectCard";
import colorSharp2 from "../assets/img/color-sharp2.png";
import projImg1 from "../assets/img/proImg1.png";
import projImg2 from "../assets/img/proImg2.png";
import projImg3 from "../assets/img/proImg3.png";
import projImg4 from "../assets/img/proImg4.png";
import { useState } from "react";

export const Projects = () => {
  const [activeKey, setActiveKey] = useState("first"); // Initialize activeKey state

  const projectsTab1 = [
    {
      title: "Portfolio 1.0",
      description:
        "This initial version of my portfolio website was developed using mostly HTML and CSS with vanilla JavaScript sprinkled in for some useful functionality.",
      imgUrl: projImg1,
    },
    {
      title: "Smart Shopping List",
      description:
        "A smart shopping list app that allows users to keep track of the items they purchase and learns the purchase frequency of those items. This app is mobile and accessibility (a11y) friendly.",
      imgUrl: projImg2,
    },
    {
      title: "Really Simple CRM",
      description:
        "This is a web-based CRM (Customer Relationship Management) system built using Django. It is designed to help businesses manage their customer contacts.",
      imgUrl: projImg3,
    },
  ];

  // const projectsTab2 = []; // later add more projects and update JSX commented out code below
  const projectsTab2 = [
    {
      title: "Fictional University",
      description:
        "A custom WordPress theme website (Content Management System) built using HTML, CSS, PHP, and JavaScript.",
      imgUrl: projImg4,
    },
    {
      title: "Coming Soon",
      description: "",
      // imgUrl: projImg2,
    },
    {
      title: "Coming Soon",
      description: "",
      // imgUrl: projImg3,
    },
  ];

  // const projectsTab3 = []; // later add more projects and update JSX commented out code below

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col>
            <h2>Projects</h2>
            <p>
              Below you will find a selection of my projects, each representing
              a unique challenge and learning experience. Each project has
              helped me grow as a developer and allowed me to apply my knowledge
              in practical scenarios. Please feel free to explore them in more
              detail{" "}
              <a
                href="https://github.com/shirenekboyd"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              .
            </p>
            <Tab.Container
              id="projects-tabs"
              defaultActiveKey="first"
              activeKey={activeKey}
              onSelect={(key) => setActiveKey(key)}
            >
              <Nav
                variant="pills"
                className="nav-pills mb-5 justify-content-center align-items-center"
                id="pills-tab"
              >
                <Nav.Item>
                  <Nav.Link eventKey="first">Tab One</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="second">Tab Two</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="third">Tab Three</Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="first">
                  <Row>
                    {projectsTab1.map((project, index) => {
                      return (
                        <ProjectCard key={index} {...project}></ProjectCard>
                      );
                    })}
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="second">
                  {activeKey === "second" && (
                    <Row>
                      {projectsTab2.map((project, index) => {
                        return (
                          <ProjectCard key={index} {...project}></ProjectCard>
                        );
                      })}
                    </Row>
                  )}
                </Tab.Pane>
                <Tab.Pane eventKey="third">
                  {activeKey === "third" && (
                    <Row>
                      <p>Coming Soon...</p>
                    </Row>
                  )}
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt=""></img>
    </section>
  );
};
